<!-- InputField.vue -->
<template>
  <DbSelect
    v-model="selected"
    :value="selected"
    @change="handleInput"
    :disabled="disabled"
    :ariainvalid="ariainvalid"
    class="w-full hydrated"
    name="height"
  >
    <option select></option>
    <option
      v-for="(containerType, index) in options"
      :key="index"
      :index="index"
      :value="options[index]"
      :selected="index === selected"
    >
      {{ $t(`order.containerType.${options[index]}`) }}
    </option>
  </DbSelect>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits } from "vue";
import DbSelect from "../DB-Components/DbSelect.vue";

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  lengthRestriction: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  ariainvalid: {
    type: Boolean,
    default: false,
    required: false,
  },
});
// set options to conditionally generate based on input length
type LengthToTypeOptions = {
  [key: number]: string[];
};
let lengthsToTypes = ref<LengthToTypeOptions>({
  20: ["BOX", "WB", "TANK", "HC", "OTOP", "REEF", "FLAT", "HARDTP", "BULK"],
  21: ["BOX", "WB", "TANK", "HC", "OTOP", "REEF", "FLAT", "HARDTP", "BULK"],
  22: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  23: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  24: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  26: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  30: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  31: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  35: ["BOX", "WB"],
  40: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  42: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  44: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  45: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  60: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  81: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  82: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  84: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  85: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  86: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  91: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  94: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  96: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  97: [
    "BOX",
    "WB",
    "TANK",
    "HC",
    "JWB",
    "OTOP",
    "REEF",
    "FLAT",
    "HARDTP",
    "BULK",
  ],
  10: ["SANH"],
});
// an object that maps each number to a list of possible types (keywords)

let options = ref<string[]>(lengthsToTypes.value[props.lengthRestriction]);
let selected = ref(options.value.indexOf(props.modelValue));
const emit = defineEmits(["update:modelValue"]);

const handleInput = (event: HTMLInputElement) => {
  let target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
};
</script>
